<template>
    <el-dialog :close-on-click-modal="false" :title="titleDialog" :visible="showDialog" top="7vh" @close="close"
        @open="create" custom-class="pos-payment-dialog">

        <Keypress key-event="keyup" @success="checkKey" />

        <form autocomplete="off" @submit.prevent="clickAddItem">
            <div class="form-body">
                <div class="row">
                    <div class="col-12">
                        <el-checkbox v-model="various_item" @change="setVariousItem" :disabled="isUpdateItem">
                            Producto manual
                        </el-checkbox>
                    </div>
                    <div class="col-md-7 col-lg-7 col-xl-7 col-sm-7">
                        <template v-if="various_item">
                            <div class="form-group">
                                <label class="control-label">Descripción del Producto/Servicio</label>
                                <el-input v-model="form.item.description" ref="inputItemDescription" maxlength="500">
                                </el-input>
                            </div>
                        </template>

                        <template v-else>
                            <div id="custom-select" :class="{ 'has-danger': errors.item_id }" class="form-group">
                                <label class="control-label">
                                    Producto/Servicio
                                    <a v-if="can_add_new_product" href="#" @click.prevent="showDialogNewItem = true">
                                        [+ Nuevo]
                                    </a>
                                </label>

                                <template v-if="!search_item_by_barcode" id="select-append">
                                    <el-input id="custom-input">
                                        <el-select id="select-width" ref="selectSearchNormal" slot="prepend"
                                            tabindex="1" v-model="form.item_id" :disabled="isUpdateItem"
                                            :loading="loading_search" :remote-method="searchRemoteItems" filterable
                                            placeholder="Buscar" popper-class="el-select-items" remote
                                            @change="changeItem" @focus="focusSelectItem"
                                            @visible-change="focusTotalItem">

                                            <el-tooltip v-for="option in items" :key="option.id" placement="left">
                                                <div slot="content" v-html="ItemSlotTooltipView(option)"></div>
                                                <el-option :label="ItemOptionDescriptionView(option)"
                                                    :value="option.id"></el-option>

                                            </el-tooltip>
                                        </el-select>
                                        <el-tooltip slot="append" :disabled="isUpdateItem" class="item"
                                            content="Ver Stock del Producto" effect="dark" placement="bottom">
                                            <el-button :disabled="isUpdateItem" @click.prevent="clickWarehouseDetail()">
                                                <i class="fa fa-search"></i>
                                            </el-button>
                                        </el-tooltip>
                                    </el-input>
                                </template>
                                <template v-else>
                                    <el-input id="custom-input">
                                        <el-select id="select-width" ref="selectBarcode" slot="prepend"
                                            v-model="form.item_id" :disabled="isUpdateItem" :loading="loading_search"
                                            :remote-method="searchRemoteItems" filterable placeholder="Buscar"
                                            popper-class="el-select-items" remote value-key="id" @change="changeItem">
                                            <el-option v-for="option in items" :key="option.id"
                                                :label="option.full_description" :value="option.id"></el-option>
                                        </el-select>
                                        <el-tooltip slot="append" :disabled="isUpdateItem" class="item"
                                            content="Ver Stock del Producto" effect="dark" placement="bottom">
                                            <el-button :disabled="isUpdateItem" @click.prevent="clickWarehouseDetail()">
                                                <i class="fa fa-search"></i>
                                            </el-button>
                                        </el-tooltip>
                                    </el-input>
                                </template>

                                <template v-if="!is_client">
                                    <el-checkbox v-model="search_item_by_barcode" :disabled="isUpdateItem">Buscar por
                                        código de
                                        barras
                                    </el-checkbox>
                                    <br>
                                </template>
                                <el-checkbox v-model="form.has_plastic_bag_taxes" :disabled="isEditItemNote">Impuesto a
                                    la
                                    Bolsa Plástica
                                </el-checkbox>
                                <small v-if="errors.item_id" class="form-control-feedback"
                                    v-text="errors.item_id[0]"></small>
                            </div>
                        </template>
                    </div>
                    <div class="col-md-5">
                        <div :class="{ 'has-danger': errors.affectation_igv_type_id }" class="form-group">
                            <label class="control-label">Afectación Igv</label>
                            <el-select v-model="form.affectation_igv_type_id"
                                :disabled="!change_affectation_igv_type_id || isUpdateItem" filterable>
                                <el-option v-for="option in affectation_igv_types" :key="option.id"
                                    :label="option.description" :value="option.id"></el-option>
                            </el-select>
                            <el-checkbox v-model="change_affectation_igv_type_id" :disabled="isUpdateItem">
                                Editar
                            </el-checkbox>
                            <small v-if="errors.affectation_igv_type_id" class="form-control-feedback"
                                v-text="errors.affectation_igv_type_id[0]"></small>
                        </div>
                    </div>

                    <div class="col-md-4 col-sm-4">
                        <div :class="{ 'has-danger': errors.quantity }" class="form-group">

                            <label class="control-label">Cantidad</label>
                            <el-input tabindex="2" ref="inputQuantity" v-model="form.quantity"
                                :disabled="form.item.calculate_quantity" @blur="validateQuantity"
                                @input.native="changeValidateQuantity">
                                <el-button slot="prepend"
                                    :disabled="form.quantity < 0.01 || form.item.calculate_quantity"
                                    icon="el-icon-minus" style="padding-right: 5px ;padding-left: 12px"
                                    @click="clickDecrease"></el-button>
                                <el-button slot="append" :disabled="form.item.calculate_quantity" icon="el-icon-plus"
                                    style="padding-right: 5px ;padding-left: 12px" @click="clickIncrease"></el-button>
                            </el-input>
                            <small v-if="errors.quantity" class="form-control-feedback"
                                v-text="errors.quantity[0]"></small>

                        </div>
                    </div>

                    <div class="col-md-4 col-sm-4">
                        <div :class="{ 'has-danger': errors.unit_price_value }" class="form-group">
                            <label class="control-label">Precio Unitario</label>

                            <template v-if="applyChangeCurrencyItem && changeCurrencyFromParent">

                                <el-input tabindex="3" v-model="form.unit_price_value" :readonly="!edit_unit_price"
                                    @input="calculateQuantity">

                                    <template v-if="form.item.currency_type_symbol">
                                        <el-select slot="prepend" v-model="form.item.currency_type_id"
                                            class="custom-change-select-currency">
                                            <el-option v-for="option in currencyTypes" :key="option.id"
                                                :label="option.symbol" :value="option.id"></el-option>
                                        </el-select>
                                    </template>
                                </el-input>

                            </template>
                            <template v-else>

                                <el-input tabindex="3" v-model="form.unit_price_value" :readonly="!edit_unit_price"
                                    @input="calculateQuantity">
                                    <template v-if="form.item.currency_type_symbol" slot="prepend">
                                        {{ form.item.currency_type_symbol }}
                                    </template>
                                </el-input>

                            </template>

                            <small v-if="errors.unit_price_value" class="form-control-feedback"
                                v-text="errors.unit_price[0]"></small>
                        </div>
                    </div>

                    <div class="col-md-4 col-sm-4">
                        <div class="form-group">
                            <label class="control-label">Total</label>
                            <el-input v-model="readonly_total" readonly @input="calculateTotal"></el-input>
                        </div>
                    </div>

                    <div v-if="showLots" class="col-md-3 col-sm-3" style="padding-top: 1%;">
                        <a class="text-center font-weight-bold text-info" href="#"
                            @click.prevent="clickLotGroup">[&#10004;
                            Seleccionar
                            lote]</a>
                    </div>

                    <div v-if="showSeries" class="col-md-3 col-sm-3" style="padding-top: 1%;">
                        <a class="text-center font-weight-bold text-info" href="#"
                            @click.prevent="clickSelectLots">[&#10004;
                            Seleccionar
                            series]</a>
                    </div>

                    <div v-show="form.item.calculate_quantity" class="col-md-3 col-sm-6">
                        <div :class="{ 'has-danger': errors.total_item }" class="form-group">
                            <label class="control-label">Total venta producto</label>
                            <el-input ref="total_item" v-model="total_item" :min="0.01" @input="calculateQuantity">
                                <template v-if="form.item.currency_type_symbol" slot="prepend">
                                    {{ form.item.currency_type_symbol }}
                                </template>
                            </el-input>
                            <small v-if="errors.total_item" class="form-control-feedback"
                                v-text="errors.total_item[0]"></small>
                        </div>
                    </div>
                    <div v-if="config.edit_name_product" class="col-md-12 col-sm-12 mt-2">
                        <div class="form-group">
                            <label class="control-label">Nombre producto en PDF</label>
                            <vue-ckeditor v-model="form.name_product_pdf" :editors="editors"
                                type="classic"></vue-ckeditor>
                        </div>
                    </div>
                    <!--<div class="col-md-6 mt-4" v-if="form.item_id && form.item.series_enabled">
                        <a href="#"  class="text-center font-weight-bold text-info" @click.prevent="clickSelectLots">[&#10004; Seleccionar series]</a>
                    </div> -->
                    <template v-if="!is_client">

                        <tenant-presentation-price-selector :rows="form.item_unit_types"
                            :selected-presentation="item_unit_type" @select-price="applyPresentationPrice"
                            @clear="clearPresentationPrice"></tenant-presentation-price-selector>

                        <div class="col-md-12 mt-2" v-if="!isUpdateItem">
                            <el-collapse v-model="activePanel">
                                <el-collapse-item :disabled="isUpdateItem" name="1"
                                    title="+ Agregar Descuentos/Cargos/Atributos especiales">
                                    <div v-if="discount_types.length > 0">
                                        <label class="control-label">
                                            Descuentos
                                            <a href="#" @click.prevent="clickAddDiscount">[+ Agregar]</a>
                                        </label>
                                        <table class="table">
                                            <thead>
                                                <tr>
                                                    <th>Tipo</th>
                                                    <th>Descripción</th>
                                                    <th>Porcentaje</th>
                                                    <th></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(row, index) in form.discounts" :key="index">
                                                    <td>
                                                        <el-select v-model="row.discount_type_id"
                                                            @change="changeDiscountType(index)">
                                                            <el-option v-for="option in discount_types" :key="option.id"
                                                                :label="option.description"
                                                                :value="option.id"></el-option>
                                                        </el-select>
                                                    </td>
                                                    <td>
                                                        <el-input v-model="row.description"></el-input>
                                                    </td>
                                                    <td>
                                                        <el-checkbox v-model="row.is_amount">Ingresar monto fijo
                                                        </el-checkbox>
                                                        <br>
                                                        <el-input v-model="row.percentage"></el-input>
                                                    </td>
                                                    <td>
                                                        <button class="btn btn-danger" type="button"
                                                            @click.prevent="clickRemoveDiscount(index)">x
                                                        </button>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div v-if="charge_types.length > 0">
                                        <label class="control-label">
                                            Cargos
                                            <a href="#" @click.prevent="clickAddCharge">[+ Agregar]</a>
                                        </label>
                                        <table class="table">
                                            <thead>
                                                <tr>
                                                    <th>Tipo</th>
                                                    <th>Descripción</th>
                                                    <th>Porcentaje</th>
                                                    <th></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(row, index) in form.charges" :key="index">
                                                    <td>
                                                        <el-select v-model="row.charge_type_id"
                                                            @change="changeChargeType(index)">
                                                            <el-option v-for="option in charge_types" :key="option.id"
                                                                :label="option.description"
                                                                :value="option.id"></el-option>
                                                        </el-select>
                                                    </td>
                                                    <td>
                                                        <el-input v-model="row.description"></el-input>
                                                    </td>
                                                    <td>
                                                        <el-input v-model="row.percentage"></el-input>
                                                    </td>
                                                    <td>
                                                        <button class="btn btn-danger" type="button"
                                                            @click.prevent="clickRemoveCharge(index)">x
                                                        </button>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div v-if="attribute_types.length > 0">
                                        <label class="control-label">
                                            Atributos
                                            <a href="#" @click.prevent="clickAddAttribute">[+ Agregar]</a>
                                        </label>
                                        <table class="table">
                                            <thead>
                                                <tr>
                                                    <th>Tipo</th>
                                                    <th>Descripción</th>
                                                    <th></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(row, index) in form.attributes" :key="index">
                                                    <td>
                                                        <el-select v-model="row.attribute_type_id" filterable
                                                            @change="changeAttributeType(index)">
                                                            <el-option v-for="option in attribute_types"
                                                                :key="option.id" :label="option.description"
                                                                :value="option.id"></el-option>
                                                        </el-select>
                                                    </td>
                                                    <td>
                                                        <el-input v-model="row.value"
                                                            @input="inputAttribute(index)"></el-input>
                                                    </td>
                                                    <td>
                                                        <button class="btn btn-danger" type="button"
                                                            @click.prevent="clickRemoveAttribute(index)">x
                                                        </button>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </el-collapse-item>
                            </el-collapse>
                        </div>
                    </template>
                </div>
            </div>
            <!-- @todo: Mejorar evitando duplicar codigo -->
            <!-- Mostrar en cel -->

            <div class="row hidden-md-up form-actions text-center">
                <div class="col-12">
                    &nbsp;
                </div>
                <div class="col-6">

                    <el-popover placement="top-start" :open-delay="1000" width="135" trigger="hover"
                        content="Presiona ESC">
                        <el-button slot="reference" @click.prevent="close()">
                            Cerrar
                        </el-button>
                    </el-popover>
                </div>
                <div class="col-6">
                    <el-button v-if="form.item_id" class="add form-control btn btn-primary" native-type="submit"
                        type="primary">
                        {{ titleAction }}
                    </el-button>
                </div>
            </div>
            <!-- @todo: Mejorar evitando duplicar codigo -->
            <!-- Mostrar en cel -->
            <!-- @todo: Mejorar evitando duplicar codigo -->
            <!-- Ocultar en cel -->

            <div class="form-actions text-right pt-2  hidden-sm-down">
                <el-popover placement="top-start" title="Acceso directo" width="145" trigger="hover"
                    content="Presiona ESC">
                    <el-button slot="reference" @click.prevent="close()">
                        Cerrar
                    </el-button>
                </el-popover>
                <el-button v-if="form.item_id" class="add" native-type="submit" type="primary">
                    {{ titleAction }}
                    <!-- Agregar -->
                </el-button>
            </div>
        </form>
        <item-form :external="true" :showDialog.sync="showDialogNewItem"></item-form>


        <warehouses-detail :isUpdateWarehouseId="isUpdateWarehouseId" :showDialog.sync="showWarehousesDetail"
            :warehouses="warehousesDetail">
        </warehouses-detail>

        <lots-group :lots_group="form.lots_group" :quantity="form.quantity" :showDialog.sync="showDialogLots"
            :isUpdateItem="isUpdateItem" :oldSelectedLotsGroup="old_selected_lots_group"
            @addRowLotGroup="addRowLotGroup">
        </lots-group>

        <select-lots-form :saleNoteItemId="form.sale_note_item_id" :itemId="form.item_id" :lots="lots"
            :quantity="form.quantity" :showDialog.sync="showDialogSelectLots" @addRowSelectLot="addRowSelectLot">
        </select-lots-form>


    </el-dialog>
</template>
<style>
.el-select-dropdown {
    max-width: 80% !important;
    margin-right: 5% !important;
}
</style>

<script>

import ItemForm from '../../items/form.vue'
import LotsGroup from './lots_group.vue'

import { calculateRowItem } from '../../../../helpers/functions'
import WarehousesDetail from '../../documents/partials/select_warehouses.vue'
import SelectLotsForm from '../../documents/partials/lots.vue'

import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
import VueCkeditor from 'vue-ckeditor5'
import { mapActions, mapState } from "vuex/dist/vuex.mjs";
import { ItemOptionDescription, ItemSlotTooltip } from "../../../../helpers/modal_item";
import Keypress from "vue-keypress";

export default {
    props: [
        'recordItem',
        'showDialog',
        'operationTypeId',
        'currencyTypeIdActive',
        'exchangeRateSale',
        'typeUser',
        'isEditItemNote',
        'configuration',
        'documentTypeId',
        'noteCreditOrDebitTypeId',
        'percentageIgv',
        'currencyTypes',
        'showOptionChangeCurrency',
    ],
    components: {
        ItemForm,
        WarehousesDetail,
        LotsGroup,
        Keypress,
        SelectLotsForm,
        'vue-ckeditor': VueCkeditor.component
    },
    data() {
        return {
            extra_temp: undefined,
            can_add_new_product: false,
            loading_search: false,
            titleAction: '',
            is_client: false,
            titleDialog: 'Agregar Producto o Servicio',
            resource: 'sale-notes',
            showDialogNewItem: false,
            has_list_prices: false,
            errors: {},
            form: {},
            all_items: [],
            items: [],
            operation_types: [],
            all_affectation_igv_types: [],
            aux_items: [],
            affectation_igv_types: [],
            system_isc_types: [],
            discount_types: [],
            charge_types: [],
            attribute_types: [],
            use_price: 1,
            change_affectation_igv_type_id: false,
            activePanel: 0,
            total_item: 0,
            item_unit_types: [],
            item_unit_type: {},
            showWarehousesDetail: false,
            warehousesDetail: [],
            showListStock: false,
            search_item_by_barcode: false,
            isUpdateWarehouseId: null,
            showDialogLots: false,
            showDialogSelectLots: false,
            lots: [],
            editors: {
                classic: ClassicEditor
            },
            value1: 'hello',
            readonly_total: 0,
            old_selected_lots_group: [],
            various_item: false,
            various_item_barcode: 'VARIOUS_ITEM',
            validate_stock_add_item: false,
            //item_unit_type: {}
        }
    },
    created() {
        this.loadConfiguration()
        this.$store.commit('setConfiguration', this.configuration)
        this.initForm()
    },
    mounted() {
        this.getTables()
        this.$eventHub.$on('reloadDataItems', (item_id) => {
            this.reloadDataItems(item_id)
        })

        this.$eventHub.$on('selectWarehouseId', (warehouse_id) => {
            this.form.warehouse_id = warehouse_id
        })
        this.canCreateProduct();
    },
    computed: {
        ...mapState([
            'config',
        ]),
        showLots() {
            // if (
            //     this.form.item_id &&
            //     this.form.item.lots_enabled &&
            //     this.form.lots_group.length > 0
            // )

            if (this.form.item_id && this.form.item.lots_enabled) {
                return true;
            }

            return false;
        },
        showSeries() {
            if (
                this.form.item_id &&
                this.form.item.series_enabled
            ) {
                return true
            }
            return false;
        },
        documentItem() {
            if (this.recordItem !== undefined &&
                this.recordItem !== null &&
                this.recordItem.id !== undefined &&
                this.recordItem.id !== 0) {
                this.form.document_item_id = this.recordItem.id;
                return this.recordItem.id;
            }
            return this.form.document_item_id;
        },
        edit_unit_price() {
            if (this.typeUser === 'admin') {
                return true
            }
            if (this.typeUser === 'seller') {
                return this.config.allow_edit_unit_price_to_seller;
            }
            return false;
        },
        isUpdateItem() {
            return !_.isEmpty(this.recordItem)
        },
        enabledSearchFactoryCodeItems() {
            if (this.configuration) return this.configuration.search_factory_code_items ? 1 : 0
            return 0
        },
        applyChangeCurrencyItem() {
            if (this.configuration) return this.configuration.change_currency_item
            return false
        },
        changeCurrencyFromParent() {
            return (this.showOptionChangeCurrency !== undefined && this.showOptionChangeCurrency && this.currencyTypes !== undefined && Array.isArray(this.currencyTypes))
        },
    },
    methods: {
        ...mapActions([
            'loadConfiguration',
        ]),
        hasAttributes() {
            if (
                this.form.item !== undefined &&
                this.form.item.attributes !== undefined &&
                this.form.item.attributes !== null &&
                this.form.item.attributes.length > 0
            ) {
                return true
            }

            return false;
        },
        ItemSlotTooltipView(item) {
            return ItemSlotTooltip(item);
        },
        ItemOptionDescriptionView(item) {
            return ItemOptionDescription(item)
        },
        getTables() {
            this.$http.get(`/${this.resource}/item/tables`).then(response => {
                let data = response.data
                this.all_items = data.items
                // this.items =data.items
                this.operation_types = data.operation_types
                this.all_affectation_igv_types = data.affectation_igv_types
                this.affectation_igv_types = data.affectation_igv_types
                this.system_isc_types = data.system_isc_types
                this.discount_types = data.discount_types
                this.charge_types = data.charge_types
                this.attribute_types = data.attribute_types
                this.is_client = data.is_client
                this.validate_stock_add_item = Boolean(
                    Number(data.validate_stock_add_item)
                )
                this.filterItems()

            })
        },

        canCreateProduct() {
            if (this.typeUser === 'admin') {
                this.can_add_new_product = true
            } else if (this.typeUser === 'seller') {
                if (this.config !== undefined && this.config.seller_can_create_product !== undefined) {
                    this.can_add_new_product = this.config.seller_can_create_product;
                }
            }
            return this.can_add_new_product;
        },
        validateQuantity() {

            if (!this.form.quantity) {
                this.setMinQuantity()
            }

            if (isNaN(Number(this.form.quantity))) {
                this.setMinQuantity()
            }

            if (typeof parseFloat(this.form.quantity) !== 'number') {
                this.setMinQuantity()
            }

            if (this.form.quantity <= this.getMinQuantity()) {
                this.setMinQuantity()
            }

            this.calculateTotal()
        },
        changeValidateQuantity(event) {
            this.calculateTotal()
        },
        getMinQuantity() {
            return 0.01
        },
        setMinQuantity() {
            this.form.quantity = this.getMinQuantity()
        },
        clickDecrease() {

            this.form.quantity = parseInt(this.form.quantity - 1)

            if (this.form.quantity <= this.getMinQuantity()) {
                this.setMinQuantity()
                return
            }

            this.calculateTotal()

        },
        clickIncrease() {
            this.form.quantity = parseInt(this.form.quantity) + 1
            this.calculateTotal()
        },
        async searchRemoteItems(input) {
            if (input.length > 2) {
                this.loading_search = true
                const params = {
                    'input': input,
                    'search_by_barcode': this.search_item_by_barcode ? 1 : 0,
                    'search_factory_code_items': this.enabledSearchFactoryCodeItems
                }
                await this.$http.get(`/${this.resource}/search-items/`, { params })
                    .then(response => {
                        this.items = response.data.items
                        this.loading_search = false
                        this.enabledSearchItemsBarcode()
                        this.enabledSearchItemBySeries()
                        if (this.items.length == 0) {
                            this.filterItems()
                        }
                    })
            } else {
                await this.filterItems()
            }

        },
        filterItems() {
            this.items = this.all_items
        },
        enabledSearchItemsBarcode() {
            if (this.search_item_by_barcode) {
                if (this.$refs.selectBarcode) {
                    this.$refs.selectBarcode.$data.selectedLabel = '';
                }

                if (this.items.length == 1) {
                    this.form.item_id = this.items[0].id

                    if (this.$refs.selectBarcode) {
                        this.$refs.selectBarcode.blur()
                    }

                    this.changeItem()
                }
            }
        },
        async enabledSearchItemBySeries() {

            if (this.config.search_item_by_series && this.items.length == 1) {

                this.$notify({ title: "Serie ubicada", message: "Producto añadido!", type: "success", duration: 1200 });
                this.form.item_id = this.items[0].id;
                this.$refs.selectSearchNormal.$data.selectedLabel = '';

                await this.changeItem();

                this.lots = await this.form.item.lots.map((lot) => {
                    lot.has_sale = true
                })

                await this.clickAddItem()

                this.$refs.selectSearchNormal.$data.selectedLabel = '';
            }

            if (this.config.search_item_by_series && this.items.length == 0) {
                this.$notify({ title: "Serie no ubicada", message: "", type: "warning", duration: 1200 });
            }

        },
        filterMethod(query) {

            let item = _.find(this.items, { 'internal_id': query });

            if (item) {
                this.form.item_id = item.id
                this.changeItem()
            }
        },
        clickWarehouseDetail() {

            if (!this.form.item_id) {
                return this.$message.error('Seleccione un item');
            }

            let item = _.find(this.items, { 'id': this.form.item_id });

            this.warehousesDetail = item.warehouses
            this.showWarehousesDetail = true
        },
        // filterItems(){
        //     this.items = this.items.filter(item => item.warehouses.length >0)
        // },
        initForm() {
            this.errors = {};

            this.form = {
                // category_id: [1],
                // edit: false,
                item_id: null,
                item: {},
                affectation_igv_type_id: null,
                affectation_igv_type: {},
                has_isc: false,
                system_isc_type_id: null,
                percentage_isc: 0,
                suggested_price: 0,
                quantity: 1,
                unit_price: 0,
                unit_price_value: 0,
                input_unit_price: 0,
                input_unit_price_value: 0,
                charges: [],
                discounts: [],
                attributes: [],
                has_igv: null,
                is_set: false,
                item_unit_types: [],
                has_plastic_bag_taxes: false,
                series_enabled: false,
                warehouse_id: null,
                lots_group: [],
                IdLoteSelected: null,
                document_item_id: null,
                name_product_pdf: '',
                sale_note_item_id: null,
                record_id: null,
            };

            this.activePanel = 0;
            this.total_item = 0;
            this.item_unit_type = {};
            this.lots = []
            this.has_list_prices = false;
        },
        // initializeFields() {
        //     this.form.affectation_igv_type_id = this.affectation_igv_types[0].id
        // },
        async create() {

            this.titleDialog = (this.isUpdateItem) ? ' Editar Producto o Servicio' : ' Agregar Producto o Servicio';
            this.titleAction = (this.isUpdateItem) ? ' Editar' : ' Agregar';
            if (this.operation_types !== undefined) {
                let operation_type = await _.find(this.operation_types, { id: this.operationTypeId })
                if (operation_type !== undefined) {
                    this.affectation_igv_types = await _.filter(this.all_affectation_igv_types, { exportation: operation_type.exportation })
                }
            }

            // console.log(this.recordItem, "aq")

            this.updateItem()

            this.$refs.selectSearchNormal.$el.getElementsByTagName('input')[0].focus()

        },
        // edicion de item
        searchGetIdLoteSelected() {

            if (this.old_selected_lots_group.length > 0) {
                let new_id_lote_selected = []

                this.old_selected_lots_group.forEach(lot => {

                    let search_lot = _.find(this.form.lots_group, { id: lot.id })

                    if (search_lot) {
                        search_lot.compromise_quantity = lot.compromise_quantity
                        new_id_lote_selected.push(lot)
                    }

                })

                if (new_id_lote_selected.length > 0) {
                    return new_id_lote_selected
                }
            }

            return null

        },
        regularizeCompromiseQuantityLots() {

            this.form.IdLoteSelected.forEach(lot => {
                let search_lot = _.find(this.form.lots_group, { id: lot.id })
                if (search_lot) search_lot.compromise_quantity = lot.compromise_quantity
            })

        },
        setIdLoteSelected() {
            // console.log(this.recordItem.item.IdLoteSelected)

            if (this.recordItem.item.IdLoteSelected) {
                this.old_selected_lots_group = this.recordItem.item.IdLoteSelected
                this.form.IdLoteSelected = this.recordItem.item.IdLoteSelected
                this.regularizeCompromiseQuantityLots()
            }
            else {
                if (this.recordItem.item.lots_group) {
                    this.old_selected_lots_group = _.filter(this.recordItem.item.lots_group, function (lot) { return lot.compromise_quantity > 0 })
                    this.form.IdLoteSelected = this.searchGetIdLoteSelected()
                }
            }

        },
        setItemLots() {

            if (this.recordItem.item.lots) {
                this.form.sale_note_item_id = this.recordItem.record_id
                this.form.item.lots = this.recordItem.item.lots
                this.lots = this.recordItem.item.lots
            }

        },
        setNameProductPdf() {

            if (this.recordItem.item.name_product_pdf) {
                this.form.name_product_pdf = this.recordItem.item.name_product_pdf
            }

        },
        setUnitPriceValue() {

            if (this.recordItem.item.has_igv) {
                this.form.unit_price_value = this.recordItem.input_unit_price_value ? this.recordItem.input_unit_price_value : this.recordItem.unit_price
            }
            else {
                this.form.unit_price_value = this.recordItem.input_unit_price_value ? this.recordItem.input_unit_price_value : this.recordItem.unit_value
            }

        },
        async updateItem() {

            if (this.isUpdateItem) {
                await this.reloadDataItems(this.recordItem.item_id)
                if (this.recordItem.item.barcode === this.various_item_barcode) {
                    this.various_item = true
                    this.form.item.description = this.recordItem.item.description
                } else {
                    this.various_item = false
                }

                this.form.quantity = parseFloat(this.recordItem.quantity)
                this.setUnitPriceValue()
                this.form.has_plastic_bag_taxes = (this.recordItem.total_plastic_bag_taxes > 0) ? true : false
                this.form.warehouse_id = this.recordItem.warehouse_id
                this.isUpdateWarehouseId = this.recordItem.warehouse_id
                this.form.record_id = this.recordItem.record_id
                this.form.affectation_igv_type_id = this.recordItem.affectation_igv_type_id

                this.setIdLoteSelected()
                this.setItemLots()
                this.setPresentationEditItem()
                this.setNameProductPdf()
                this.calculateQuantity()

            } else {
                this.isUpdateWarehouseId = null
            }

        },
        // edicion de item
        setPresentationEditItem() {

            if (!_.isEmpty(this.recordItem.item.presentation)) {
                this.selectedPrice(this.recordItem.item.presentation)
                this.getSelectedClass(this.recordItem.item.presentation)
            }

        },
        async regularizeLots() {

            if (this.form.document_item_id && this.form.item.lots.length > 0) {

                await this.$http.get(`/${this.resource}/regularize-lots/${this.form.document_item_id}`).then((response) => {

                    let all_lots = this.form.item.lots
                    let available_lots = response.data

                    all_lots.forEach((lot, index) => {

                        let exist_lot = _.find(available_lots, (it) => {
                            return it.id == lot.id
                        })

                        if (!exist_lot) {
                            this.form.item.lots.splice(index, 1)
                        }

                    })
                })
                    .catch(error => {
                    })
                    .then(() => {
                    })

            }

        },
        clickAddDiscount() {
            this.form.discounts.push({
                discount_type_id: null,
                discount_type: null,
                description: null,
                percentage: 0,
                factor: 0,
                amount: 0,
                base: 0,
                is_amount: false
            })
        },
        clickRemoveDiscount(index) {
            this.form.discounts.splice(index, 1)
        },
        changeDiscountType(index) {
            let discount_type_id = this.form.discounts[index].discount_type_id
            this.form.discounts[index].discount_type = _.find(this.discount_types, { id: discount_type_id })
        },
        clickAddCharge() {
            this.form.charges.push({
                charge_type_id: null,
                charge_type: null,
                description: null,
                percentage: 0,
                factor: 0,
                amount: 0,
                base: 0
            })
        },
        clickRemoveCharge(index) {
            this.form.charges.splice(index, 1)
        },
        changeChargeType(index) {
            let charge_type_id = this.form.charges[index].charge_type_id
            this.form.charges[index].charge_type = _.find(this.charge_types, { id: charge_type_id })
        },
        clickAddAttribute() {
            this.form.attributes.push({
                attribute_type_id: null,
                description: null,
                value: null,
                start_date: null,
                end_date: null,
                duration: null,
            })
        },
        clickRemoveAttribute(index) {
            this.form.attributes.splice(index, 1)
        },
        changeAttributeType(index) {
            let attribute_type_id = this.form.attributes[index].attribute_type_id
            let attribute_type = _.find(this.attribute_types, { id: attribute_type_id })
            this.form.attributes[index].description = attribute_type.description
            this.inputAttribute(index)
        },
        inputAttribute(index) {

            let value = this.form.attributes[index].value
            let hotelAttributes = ['4003', '4004']

            this.form.attributes[index].start_date = (hotelAttributes.includes(this.form.attributes[index].attribute_type_id)) ? value : null

        },
        close() {
            this.various_item = false
            this.initForm()
            this.$emit('update:showDialog', false)
        },
        async changeItem() {

            this.form.item = { ..._.find(this.items, { 'id': this.form.item_id }) }
            // this.form.item = _.find(this.items, {'id': this.form.item_id});
            this.form.item_unit_types = _.find(this.items, { 'id': this.form.item_id }).item_unit_types
            this.form.unit_price_value = this.form.item.sale_unit_price;
            this.lots = this.form.item.lots

            this.form.has_igv = this.form.item.has_igv;
            this.form.has_plastic_bag_taxes = this.form.item.has_plastic_bag_taxes;
            this.form.affectation_igv_type_id = this.form.item.sale_affectation_igv_type_id;
            this.form.quantity = 1;
            this.cleanTotalItem();
            this.showListStock = true

            if (this.hasAttributes()) {
                const contex = this
                this.form.item.attributes.forEach((row) => {

                    contex.form.attributes.push({
                        attribute_type_id: row.attribute_type_id,
                        description: row.description,
                        value: row.value,
                        start_date: row.start_date,
                        end_date: row.end_date,
                        duration: row.duration,
                    })
                })
            }
            this.form.lots_group = this.form.item.lots_group
            // if (!this.recordItem) {
            //     await this.form.item.warehouses.forEach(element => {
            //         if(element.checked){
            //             this.form.warehouse_id = element.warehouse_id
            //         }
            //     });
            // }

            //this.item_unit_types = this.form.item.item_unit_types;
            //(this.item_unit_types.length > 0) ? this.has_list_prices = true : this.has_list_prices = false;
            if (!this.various_item && this.form.item.name_product_pdf && this.config.item_name_pdf_description) {
                this.form.name_product_pdf = this.form.item.name_product_pdf
            }
        },
        focusTotalItem(change) {
            if (!change && this.form.item.calculate_quantity) {
                this.$refs.total_item.$el.getElementsByTagName('input')[0].focus()
                this.total_item = this.form.unit_price_value
            }
        },
        calculateQuantity() {
            if (this.form.item.calculate_quantity) {
                this.form.quantity = _.round((this.total_item / this.form.unit_price_value), 4)
            }
            this.calculateTotal()
        },
        calculateTotal() {
            this.readonly_total = _.round((this.form.quantity * this.form.unit_price_value), 4)
        },
        cleanTotalItem() {
            this.total_item = null
        },
        getResponseMessage(success, message = null) {

            return {
                success: success,
                message: message,
            }

        },
        validateIdLoteSelected() {

            if (this.form.item.lots_enabled) {
                if (!this.form.IdLoteSelected) {
                    return this.getResponseMessage(false, 'Debe seleccionar un lote.')
                }
                else {
                    const compromise_quantity = parseFloat(_.sumBy(this.form.IdLoteSelected, 'compromise_quantity'))

                    if (compromise_quantity != parseFloat(this.form.quantity)) {
                        return this.getResponseMessage(false, 'La suma de cantidades comprometidas de los lotes debe der igual a la cantidad pedida.')
                    }
                }
            }

            return this.getResponseMessage(true)

        },
        async validateCurrentStock() {
            const data = {
                item_id: this.form.item_id,
                quantity: this.form.quantity,
                warehouse_id: this.form.warehouse_id,
                presentation: _.isEmpty(this.item_unit_type)
                    ? null
                    : this.item_unit_type,
            }

            const response = await this.$http.post(
                '/validate-current-item-stock',
                data
            )

            return response.data
        },

        applyValidateStock() {
            /*
             * No se vuelve a validar cuando se está editando una línea existente,
             * porque su stock ya fue descontado al registrar la nota.
             */
            return this.validate_stock_add_item && !this.recordItem
        },
        async clickAddItem() {
            if (
                !this.form.item.description ||
                !this.form.item.description.trim().length
            ) {
                return this.$message.error('La descripción es requerida')
            }

            this.validateQuantity()

            if (this.applyValidateStock()) {
                try {
                    const stockValidation = await this.validateCurrentStock()

                    if (!stockValidation.success) {
                        return this.$message.error(stockValidation.message)
                    }
                } catch (error) {
                    const message =
                        error.response &&
                            error.response.data &&
                            error.response.data.message
                            ? error.response.data.message
                            : 'No se pudo validar el stock del producto.'

                    return this.$message.error(message)
                }
            }

            const validate_id_lote_selected = this.validateIdLoteSelected()

            if (!validate_id_lote_selected.success) {
                return this.$message.error(
                    validate_id_lote_selected.message
                )
            }

            if (this.validateTotalItem().total_item) return;

            let affectation_igv_type_id = this.form.affectation_igv_type_id
            // let unit_price = (this.form.has_igv) ? this.form.unit_price_value : this.form.unit_price_value * 1.18;
            let unit_price = this.form.unit_price_value;
            if (this.form.has_igv === false) {
                if (
                    affectation_igv_type_id === "20" ||
                    affectation_igv_type_id === "21" ||
                    affectation_igv_type_id === "40"
                ) {
                    // do nothing
                    // exonerado de igv
                } else {
                    unit_price = this.form.unit_price_value * (1 + this.percentageIgv);

                }
            }

            //validar precio compra y venta
            if (this.configuration.validate_purchase_sale_unit_price) {
                let val_purchase_unit_price = parseFloat(this.form.item.purchase_unit_price)

                if (val_purchase_unit_price > parseFloat(unit_price)) {
                    return this.$message.error(`El precio de compra no puede ser superior al precio de venta (P. Compra: ${val_purchase_unit_price})`)
                }
            }

            this.form.input_unit_price_value = this.form.unit_price_value;

            this.form.unit_price = unit_price;
            this.form.item.unit_price = unit_price;
            this.form.item.presentation = this.item_unit_type;
            this.form.affectation_igv_type = _.find(this.affectation_igv_types, { 'id': affectation_igv_type_id });

            let IdLoteSelected = this.form.IdLoteSelected
            let document_item_id = this.form.document_item_id
            if (this.various_item) {
                this.form.name_product_pdf = `<p>${this.form.item.description}</p>`
                this.form.item.name_product_pdf = this.form.name_product_pdf
            }
            this.row = calculateRowItem(this.form, this.currencyTypeIdActive, this.exchangeRateSale, this.percentageIgv);

            this.row.item.name_product_pdf = this.row.name_product_pdf || '';


            let select_lots = await _.filter(this.row.item.lots, { 'has_sale': true })
            let un_select_lots = await _.filter(this.row.item.lots, { 'has_sale': false })

            if (this.form.item.series_enabled) {
                if (select_lots.length != this.form.quantity)
                    return this.$message.error('La cantidad de series seleccionadas son diferentes a la cantidad a vender');
            }

            // this.row.item.lots = un_select_lots
            // this.row.lots = select_lots
            this.initForm();

            if (this.recordItem) this.row.aux_index = this.recordItem.aux_index

            this.row.IdLoteSelected = IdLoteSelected
            this.row.document_item_id = document_item_id

            this.$emit('add', this.row);

            if (this.search_item_by_barcode) {
                this.cleanItems()
            }

            if (this.recordItem) {
                this.close();
            } else {
                this.setFocusSelectItem();
            }
        },
        cleanItems() {
            this.items = []
            this.$refs.selectBarcode.$el.getElementsByTagName('input')[0].focus()
            // console.log("add cart barcode")
        },
        validateTotalItem() {

            this.errors = {}

            if (this.form.item.calculate_quantity) {
                if (this.total_item < 0.01)
                    this.$set(this.errors, 'total_item', ['total venta item debe ser mayor a 0.01']);
            }

            return this.errors
        },
        async reloadDataItems(item_id) {

            if (!item_id) {

                await this.$http.get(`/${this.resource}/table/items`).then((response) => {
                    this.items = response.data
                    this.form.item_id = item_id
                    // if(item_id) this.changeItem()
                    // this.filterItems()
                })

            } else {

                await this.$http.get(`/${this.resource}/search/item/${item_id}`).then((response) => {

                    this.items = response.data
                    // this.items = response.data.items
                    this.form.item_id = item_id
                    this.changeItem()

                })
            }

        },
        changePresentation() {
            let price = 0;

            this.item_unit_type = _.find(this.form.item.item_unit_types, { 'id': this.form.item_unit_type_id });

            switch (this.item_unit_type.price_default) {
                case 1:
                    price = this.item_unit_type.price1
                    break;
                case 2:
                    price = this.item_unit_type.price2
                    break;
                case 3:
                    price = this.item_unit_type.price3
                    break;
            }

            this.form.unit_price_value = price;
            this.form.item.unit_type_id = this.item_unit_type.unit_type_id;
        },
        selectedPrice(row) {
            if (this.isSelectedPrice(row)) {
                this.form.item_unit_type_id = null
                this.item_unit_type = {}
                this.form.unit_price = this.form.item.sale_unit_price
                this.form.unit_price_value = this.form.item.sale_unit_price
                this.form.item.unit_type_id = this.form.item.original_unit_type_id
            } else {
                let valor = 0
                switch (row.price_default) {
                    case 1:
                        valor = row.price1
                        break
                    case 2:
                        valor = row.price2
                        break
                    case 3:
                        valor = row.price3
                        break

                }
                this.form.item_unit_type_id = row.id
                this.item_unit_type = row
                this.form.unit_price = valor
                this.form.unit_price_value = valor
                this.form.item.unit_type_id = row.unit_type_id
            }
            this.calculateQuantity()
            this.getTables()
        },
        addRowLotGroup(id) {
            this.form.IdLoteSelected = id
        },
        clickLotGroup() {
            this.showDialogLots = true
        },
        async clickSelectLots() {
            this.showDialogSelectLots = true
        },
        addRowSelectLot(lots) {
            this.lots = lots
        },
        focusSelectItem() {
            this.$refs.selectSearchNormal.$el.getElementsByTagName('input')[0].focus()
        },
        async setFocusSelectItem() {
            if (this.various_item) {
                await this.setVariousItem()
                this.$refs.inputItemDescription.$el.getElementsByTagName('input')[0].focus()
            } else {
                if (this.$refs.selectSearchNormal) {
                    this.$refs.selectSearchNormal.$el.getElementsByTagName('input')[0].focus()
                }
            }
        },
        async setVariousItem() {
            if (this.various_item) {
                let original_value = this.search_item_by_barcode
                this.search_item_by_barcode = true

                await this.searchRemoteItems(this.various_item_barcode)

                this.search_item_by_barcode = original_value

                if (this.form.item == null || this.form.item.barcode !== this.various_item_barcode) {
                    this.$notify({
                        title: 'Producto Manual',
                        message: `Debe registrar un producto con código de barras ${this.various_item_barcode}`,
                        type: 'error',
                        duration: 1200
                    })
                    this.various_item = false
                } else {
                    this.form.item.description = ''
                    this.$refs.inputItemDescription.$el.getElementsByTagName('input')[0].focus()
                    return
                }
            }

            this.initForm()
            this.filterItems()
        },
        isSelectedPrice(item_unit_type) {
            if (!_.isEmpty(this.item_unit_type)) {
                return (this.item_unit_type.id === item_unit_type.id)
            }
            return false
        },
        getSelectedClass(row) {
            if (this.isSelectedPrice(row)) return 'btn-success'
            return 'btn-secondary'

        },
        checkKey(e) {
            let code = e.event.code;
            if (code === 'Escape') {
                this.close()

            }


        },
        applyPresentationPrice(payload) {
            this.form.item_unit_type_id =
                payload.row.id

            this.item_unit_type =
                payload.presentation

            this.form.unit_price =
                payload.price

            /*
             * Algunos documentos utilizan también
             * unit_price_value.
             */
            if (
                Object.prototype.hasOwnProperty.call(
                    this.form,
                    'unit_price_value'
                )
            ) {
                this.form.unit_price_value =
                    payload.price
            }

            this.form.item.unit_type_id =
                payload.row.unit_type_id

            if (
                typeof this.calculateQuantity ===
                'function'
            ) {
                this.calculateQuantity()
            }
        },

        clearPresentationPrice() {
            this.form.item_unit_type_id = null
            this.item_unit_type = {}

            this.form.unit_price =
                this.form.item.sale_unit_price

            if (
                Object.prototype.hasOwnProperty.call(
                    this.form,
                    'unit_price_value'
                )
            ) {
                this.form.unit_price_value =
                    this.form.item.sale_unit_price
            }

            this.form.item.unit_type_id =
                this.form.item.original_unit_type_id ||
                this.form.item.unit_type_id

            if (
                typeof this.calculateQuantity ===
                'function'
            ) {
                this.calculateQuantity()
            }
        },

    },
}

</script>



// WEBPACK FOOTER //
// resources/js/views/tenant/sale_notes/partials/item.vue